module.exports = __webpack_public_path__ + "img/img_bg@2x.ca5a657a.png";